import { useId } from "react";

import { Label } from "~/components/ui/label";
import { RadioGroup, RadioGroupItem } from "~/hec/components/ui/radio-group";
import { cn } from "~/lib/ui";

import type { FuturePlansFieldProps } from "./types";

/** SFRA custom radio: 20px ring, 1px blue-03 border, 12px blue-04 dot. */
const radioClassName =
  "h-5 w-5 border border-blue-03 text-blue-04 [&[data-state=checked]]:border-blue-03 [&[data-state=checked]_svg]:h-3 [&[data-state=checked]_svg]:w-3";

const YES = "yes";
const NO = "no";

/**
 * Molecule: the Yes / No radio pair of the SFRA future-plans form
 * (`.c-loyalty-form__radio-group`): the group is centred, its labels are
 * left-aligned.
 */
export function FuturePlansField({
  value,
  onChange,
  yesLabel,
  noLabel,
  disabled,
  className,
  "data-testid": testId,
}: FuturePlansFieldProps) {
  const yesId = useId();
  const noId = useId();
  return (
    <RadioGroup
      value={value ? YES : NO}
      onValueChange={next => onChange(next === YES)}
      disabled={disabled}
      className={cn(
        "mb-[29px] inline-flex flex-col gap-[18px] self-center text-left",
        className,
      )}
      data-testid={testId}
    >
      <div className="flex h-6 items-center gap-4">
        <RadioGroupItem
          value={YES}
          id={yesId}
          className={radioClassName}
          data-testid={`${testId}-yes`}
        />
        <Label
          htmlFor={yesId}
          className="text-sm font-normal leading-6 text-blue-04"
        >
          {yesLabel}
        </Label>
      </div>
      <div className="flex h-6 items-center gap-4">
        <RadioGroupItem
          value={NO}
          id={noId}
          className={radioClassName}
          data-testid={`${testId}-no`}
        />
        <Label
          htmlFor={noId}
          className="text-sm font-normal leading-6 text-blue-04"
        >
          {noLabel}
        </Label>
      </div>
    </RadioGroup>
  );
}
